export const FETCH_PRINT_ORDERBOOK_LIST = "orderbook/FETCH_PRINT_ORDERBOOK_LIST";
export const FETCH_PRINT_ORDERBOOK_LIST_COMPLETED = "orderbook/FETCH_PRINT_ORDERBOOK_LIST_COMPLETED";
export const FETCH_PRINT_ORDERBOOK_LIST_FAILED = "orderbook/FETCH_PRINT_ORDERBOOK_LIST_FAILED";


export const FETCH_PRINT_ORDERBOOK_DETAILS = "orderbook/FETCH_PRINT_ORDERBOOK_DETAILS";
export const FETCH_PRINT_ORDERBOOK_DETAILS_COMPLETED = "orderbook/FETCH_PRINT_ORDERBOOK_DETAILS_COMPLETED";
export const FETCH_PRINT_ORDERBOOK_DETAILS_FAILED = "orderbook/FETCH_PRINT_ORDERBOOK_DETAILS_FAILED";